module.exports = __webpack_public_path__ + "img/aligner.81da4b8c.jpg";